import _extends from "@babel/runtime/helpers/extends";
import { Typography } from "@mui/material";
import { GridEditDateCell, GridEditInputCell, GridEditSingleSelectCell, renderEditBooleanCell, renderEditDateCell } from "@mui/x-data-grid-premium";
import { ChevronDownIcon } from "../../../../assets/customIcons";
import CellErrorIcon from "./cellErrorIcon";
import GridSearchSelect from "./gridSearchSelect";
export var renderGridSearchSelect = function (params) { /*#__PURE__*/ return React.createElement(GridSearchSelect, params); };
export var renderGridEditInputCell = function (params) { /*#__PURE__*/ return React.createElement(GridEditInputCell, _extends({}, params, {
    placeholder: params.colDef.placeholder
})); };
export var renderGridEditDateCell = function (params) { /*#__PURE__*/ return React.createElement(GridEditDateCell, _extends({}, params, {
    placeholder: params.colDef.placeholder
})); };
export var renderGridSingleSelect = function (params) { /*#__PURE__*/ return React.createElement(GridEditSingleSelectCell, _extends({}, params, {
    initialOpen: false,
    variant: "standard",
    displayEmpty: true,
    renderValue: function (value) { return value !== null && value !== void 0 ? value : /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle2",
        color: "rgba(0,0,0,0.37)"
    }, params.colDef.placeholder); },
    IconComponent: ChevronDownIcon,
    sx: {
        px: 3,
        justifyContent: 'center',
        display: 'flex',
        '& .MuiSelect-icon': {
            position: 'static'
        }
    },
    SelectDisplayProps: {
        style: {
            background: 'none'
        }
    }
})); };
export var renderGridEditCell = function (params) {
    var error = params.api.state.error;
    if ((error === null || error === void 0 ? void 0 : error.rowId) === params.id && (error === null || error === void 0 ? void 0 : error.field) === params.field && typeof error.message !== 'object') {
        params.error = true;
        params.startAdornment = /*#__PURE__*/ React.createElement(CellErrorIcon, {
            error: error.message
        });
    }
    switch (params.colDef.type) {
        case 'singleSelect':
            return renderGridSingleSelect(params);
        case 'searchSelect':
            return renderGridSearchSelect(params);
        case 'date':
        case 'dateTime':
            return renderEditDateCell(params);
        case 'boolean':
            return renderEditBooleanCell(params);
        default:
            return renderGridEditInputCell(params);
    }
};
